import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'arrow-down-right', 'ArrowDownRight', [["path",{"d":"M7 7l10 10"}],["path",{"d":"M17 8l0 9l-9 0"}]]);